/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import purchaseService from './../../services/purchase';
import productService from './../../services/product';
import { mapGetters, mapMutations } from 'vuex';
import purchaseTransformer from './../../transformers/purchaseReceive';
import Forms from './../../utils/forms/forms';
import moment from 'moment';
import store from './../../store';

export default {
  data() {
    return {
      form: new Forms({
        receiveDate: {
          value: new Date(),
          type: 'date',
        },
      }),
      fields: {
        productId: {
          value: '',
          type: 'autocomplete',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
        batchId: {
          value: '',
          type: 'select',
        },
        qty: {
          value: '0',
          type: 'number',
        },
        qtyReceive: {
          value: '0',
          type: 'number',
        },
        qtyDamage: {
          value: '0',
          type: 'number',
        },
        purchasePrice: {
          value: '0',
          type: 'number',
        },
        costPrice: {
          value: '0',
          type: 'number',
        },
        notes: {
          value: '',
          type: 'text',
        },
      },
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      currentPurchase: 'currentPurchase',
      currentStockProducts: 'currentStockProductsCustom',
    }),
  },

  mounted() {
    this.getResources();
  },

  watch: {

  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * Fetch the component's required resources.
     */
    getResources() {
      this.loading = false;
      this.defaulCostAndPurchasePrice(false);
    },

    defaulCostAndPurchasePrice(backToZero) {
      this.currentStockProducts.forEach((item, i) => {
        let update = false;
        const data = {};

        if (backToZero === false) {
          if (item.costPrice === '0') {
            data.costPrice = item.product.costPrice;
            data.originCostPrice = '0';
            update = true;
          }
          if (item.purchasePrice === '0') {
            data.purchasePrice = item.product.purchasePrice;
            data.originPurchasePrice = '0';
            update = true;
          }
        } else {
          // eslint-disable-next-line no-prototype-builtins
          if (item.hasOwnProperty('originCostPrice') && item.originCostPrice === '0') {
            data.costPrice = item.originCostPrice;
            update = true;
          }
          // eslint-disable-next-line no-prototype-builtins
          if (item.hasOwnProperty('originPurchasePrice') && item.originPurchasePrice === '0') {
            data.purchasePrice = item.originPurchasePrice;
            update = true;
          }
        }

        if (update === true) {
          data.batchId = item.batchId;
          data.id = item.id;
          data.name = item.name;
          data.notes = item.notes;
          data.product = item.product;
          data.productId = item.productId;
          data.purchaseId = item.purchaseId;
          data.qty = item.qty;
          data.qtyDamage = item.qtyDamage;
          data.qtyReceive = item.qtyReceive;

          store.dispatch('UpdateToStockProducts', { data, i });
        }
      });
    },

    searchMethod(search, field) {
      return Promise.all([
        productService.search({ search: search, warehouse_id: '' })
      ]);
    },

    store() {
      this.loading = false;
      this.form.loading = true;

      // Timezone issue. Use moment to convert to correct time.
      this.form.receiveDate = moment(this.form.receiveDate).format();

      var data = this.form.data();

      const client = purchaseTransformer.send(
        Object.assign({}, data, { products: this.currentStockProducts })
      );

      return purchaseService.markAsDone(this.currentPurchase.id, client)
        .then((data) => {
          this.form.loading = false;
          this.$message({
            showClose: true,
            message: this.$t('static.purchase.update.success'),
            customClass: 'success',
          });
          this.closeModal();
          this.$router.push({
            name: 'inventory.purchase.index',
          });
        }).catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
          let message = this.$t('static.purchase.update.error');

          if (errors.message) {
            message = errors.message;
          }
          this.$message({
            showClose: true,
            message,
            customClass: 'error',
          });
        });
    },
    /*
     * Closes the modal
     */
    closeModal() {
      this.defaulCostAndPurchasePrice(true);
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
    VProductsTable: require('./../../components/productTableWithCustomForm/productTableWithCustomForm.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/purchaseRecieve/purchaseRecieve.js